import { RequirePermission } from '@backstage/plugin-permission-react';
import { AccountsTab } from '../CatalogTabs';
import { projectAccountReadPermission } from '@internal/backstage-plugin-catalog-devops-common';

export const ProjectAccountsTab = () => {
  return (
    <RequirePermission permission={projectAccountReadPermission}>
      <AccountsTab />
    </RequirePermission>
  );
};
